import { createSvgIcon } from '@mui/material/utils';

export const LockIcon = createSvgIcon(
    <path
        d='M7.395 8.172l.324 2.91-.657.05a1.989 1.989 0 00-1.804 1.665 19.33 19.33 0 000 6.293c.144.906.89 1.59 1.804 1.664l1.41.113c2.231.176 4.47.176 6.696 0l1.414-.113a1.992 1.992 0 001.805-1.664 19.33 19.33 0 000-6.293 1.996 1.996 0 00-1.805-1.664l-.656-.051.324-2.91c.04-.344.04-.692 0-1.035l-.023-.192a4.43 4.43 0 00-4.922-3.914 4.434 4.434 0 00-3.89 3.914l-.02.192c-.04.343-.04.691 0 1.035zm4.78-3.735a2.678 2.678 0 00-.706 0A3.018 3.018 0 008.82 7.103l-.02.191c-.027.238-.027.48 0 .723l.329 2.96a41.312 41.312 0 015.387 0l.328-2.96a3.193 3.193 0 000-.723l-.024-.191a3.01 3.01 0 00-2.644-2.665zm-.355 10.094a1.414 1.414 0 100 2.828c.782 0 1.418-.632 1.418-1.414 0-.78-.636-1.414-1.418-1.414zm0 0'
        fillRule='evenodd'
    />,
    'LockIcon'
);
